<div class="row">
  <div class="col-lg-12">
    <h4>ControlBright Admin panel</h4>
  </div>
</div>

<div class="row deepstream">
  <div class="col-lg-12">
    <div class="grid">

      <div class="grid-header split-header">
        <span>
          <span class="badge deepstream-status" [class.badge-success]="deviceService.deepstreamStatus" [class.badge-danger]="!deviceService.deepstreamStatus">&nbsp;</span>
          Deepstream {{ deviceService.deepstreamStatus ? 'Online' : 'Offline'}}
        </span>
        <span>{{deviceService.devicesOnlineCount}} Devices Online</span>
      </div>

    </div>
  </div>
</div>

<div class="row provision">
  <div class="col-lg-12">
    <div class="grid">

      <div class="grid-header split-header">
        <span>Provision GLs from Spreadsheet<br />Next ID: {{nextId}}</span>
        <button type="button" class="btn btn-primary" (click)="provision()">Start!</button>
      </div>

      <app-bulk-device-edit [deviceIds]="addedDevices" *ngIf="provisionComplete"></app-bulk-device-edit>

    </div>
  </div>
</div>
